export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/d9e0c2f4ae8401c6f4fbe61470b6d586.jpeg"
          alt="ESAPCOR Robotics Academy"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center py-32">
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Đào Tạo Robotics & AI<br />
          <span className="text-orange-400">Chuẩn Quốc Tế STEAM</span>
        </h1>

        <p className="text-xl sm:text-2xl text-gray-100 mb-12 max-w-4xl mx-auto leading-relaxed">
          ESAPCOR mang đến chương trình đào tạo Robotics, IoT và AI toàn diện với giáo trình chuẩn STEAM, phòng lab hiện đại và đội ngũ mentor chuyên nghiệp, giúp học viên phát triển kỹ năng công nghệ tương lai
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16">
          <button 
            onClick={() => scrollToSection('course-form')}
            className="px-10 py-5 bg-orange-600 text-white rounded-full text-lg font-semibold hover:bg-orange-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-add-line mr-2"></i>
            Đăng ký học thử
          </button>
          <button 
            onClick={() => scrollToSection('car-form')}
            className="px-10 py-5 bg-white text-orange-600 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            Nhận báo giá Kit
          </button>
          <button 
            onClick={() => scrollToSection('partnership')}
            className="px-10 py-5 bg-transparent border-2 border-white text-white rounded-full text-lg font-semibold hover:bg-white hover:text-orange-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-handshake-line mr-2"></i>
            Tư vấn nhượng quyền
          </button>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-orange-400 mb-2">500+</div>
            <div className="text-sm text-gray-200">Học viên đã đào tạo</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-orange-400 mb-2">50+</div>
            <div className="text-sm text-gray-200">Đối tác trường học</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-orange-400 mb-2">100%</div>
            <div className="text-sm text-gray-200">Chứng nhận quốc tế</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-orange-400 mb-2">15+</div>
            <div className="text-sm text-gray-200">Năm kinh nghiệm</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}